// Single source of truth for headcount shown anywhere in the app.
// All KPI cards, charts, headers, PDFs, and the Employees widget MUST
// import from here. Do not hardcode headcount anywhere else.
//
// In dev we assert at render time that no two displayed headcount values
// diverge (see useAssertSingleHeadcount below).

import { headcountHistory } from './headcountHistory';

// Gender/diversity breakdown — update as HR data evolves.
// When Humi integration lands, replace these constants with live fetch.
const DIVERSITY = {
  men: 44,
  women: 8,
};

function latestHistoryEntry() {
  if (!headcountHistory || headcountHistory.length === 0) return null;
  // headcountHistory is chronological; last entry = most recent month
  return headcountHistory[headcountHistory.length - 1];
}

export function getCanonicalHeadcount() {
  const latest = latestHistoryEntry();
  const total = latest ? latest.total : (DIVERSITY.men + DIVERSITY.women);
  const men = DIVERSITY.men;
  const women = total - men;
  const femalePct = total > 0 ? Math.round((women / total) * 100) : 0;
  return {
    total,
    men,
    women,
    femalePct,
    month: latest?.month || null,
    departments: latest?.departments || {},
    history: headcountHistory,
  };
}

// Dev-time assertion: if two callers in the same render pass report
// different totals, throw so the mismatch is caught immediately.
const _renderSeen = { total: null, count: 0 };
export function assertHeadcountConsistent(total, caller) {
  if (process.env.NODE_ENV === 'production') return;
  if (_renderSeen.total === null) {
    _renderSeen.total = total;
    _renderSeen.count = 1;
    // Clear on next microtask so each render starts fresh
    Promise.resolve().then(() => { _renderSeen.total = null; _renderSeen.count = 0; });
  } else if (_renderSeen.total !== total) {
    // eslint-disable-next-line no-console
    console.error(
      `[headcount] divergence detected: ${caller} reported ${total}, ` +
      `but earlier caller reported ${_renderSeen.total}. ` +
      `All headcount displays must use getCanonicalHeadcount().`
    );
  }
}
